export enum DocumentTypes {
    OTHERS = "others",
    PURCHASE = "purchase",
    WITHDRAWAL = "withdrawal",
    WARNING_BLOCKS = "warning_blocks",
    UNKNOWN = "unknown",
    PURCHASE_OPERATION_TIMERS = "purchase-operation/timers",
    WITHDRAWAL_OPERATION_TIMERS = "withdrawal-operation/timers",
}
